import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getDomainValueForCode, getTimeAgo, isEmpty } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import Swal from 'sweetalert2';
import SessionContext from '../../../library/Core/SessionContext';

const ViewApplicationModal = () => {
    const { state, dispatch } = useContext(SmartContext);

    const showFlag = state?.modalFlags?.showJobViewApplication;
    const jobData = state?.modalData?.data || {};
    const [application, setApplication] = useState<any[]>([]);
    const [applicationStatus,setApplicationStatus]=useState([]);
    const { sessionState } = useContext(SessionContext);

    useEffect(() => {
            if (!showFlag || !jobData?.id) return;
    
            const fetchViewApplicationUserwise = async () => {
                try {
                    const response = await axiosClient().post(
                        `${process.env.REACT_APP_JOB_SERVER}/jobs/view-application-userwise`,
                        { jobId: jobData.id, userId : jobData?.studentId }
                    );
    
                    console.log('response', response);
    
                     if (response.data?.success) {
                         setApplication(response.data?.data);
                     }
                } catch (error) {
                    console.error(error);
                    setApplication([]);
                }
            };
    
            fetchViewApplicationUserwise();
        }, [showFlag, jobData?.id]);

    const applicationStatuses = state?.domain?.get('JOB_APPLICATION_STATUS');

    console.log("viewapplication",applicationStatuses)

    const handleChangeApplicationStatus = (value: any) => {
            setApplicationStatus(value);
    };

    useEffect(() => {
        if (application?.[0]?.applicationStatus) {
            setApplicationStatus(application[0].applicationStatus);
        }
    }, [application]);

    const submitApplication = async (primaryAppliedId:any) => {
                try {
                    if(isEmpty(applicationStatus)){
                        alert("Please select Application status");
                        return;
                    }
                    const response = await axiosClient().post(
                        `${process.env.REACT_APP_JOB_SERVER}/jobs/update-application-status`,
                        { primaryAppliedId : primaryAppliedId, applicationStatus : applicationStatus }
                    );

                     if (response.data?.success) {
                        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobViewApplication' } });
                        Swal.fire({
                            title: "Done!",
                            text: response.data.message,
                            icon: "success"
                        });               
                     }
    
                    console.log('response', response);
    
                }catch(error) {
                    console.error(error);
                    setApplication([]);
                }
    };

 return (
        <div
            className={`modal fade px-3 show`}
            style={{ display: 'block' }}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-hidden={!showFlag}
        >
            <div className="modal-dialog modal-dialog-centered max-850 mx-auto">
                <div className="modal-content radius-15">
                    <div className="modal-body p-4 p-md-5 position-relative">
                        <h5 className="font-30 font-600 mb-4">
                            {application[0]?.userName}'s Application
                        </h5>
                        <button
                            className="position-absolute top-20 right-20 text-secondary font-30 border-0 bg-transparent"
                            onClick={() =>
                                dispatch({
                                    type: 'TOGGLE_MODAL_VISIBILITY',
                                    payload: { modalName: 'showJobViewApplication' },
                                })
                            }
                        >
                            <i className="bi bi-x-circle-fill"></i>
                        </button>

                        <div className="row g-4">
                            <div className="col-12">
                                <div className="bg-gray-f5f5f5 px-4 py-3 rounded">
                                    <div className="row g-3 align-items-center">
                                        <div className="col-sm-auto">
                                            <div className="interestedCandidate-img">
                                                <img
                                                    src={application[0]?.image}
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm">
                                            <h3 className="font-24 font-600 mb-0">
                                                {application[0]?.userName}
                                               <span
                                                    className={`badge rounded-pill font-14 ms-2 ${
                                                        application[0]?.userTypeCode ===
                                                        'ALUMNI'
                                                            ? 'bg-danger'
                                                            : 'bg-warning'
                                                    }`}
                                                >
                                                {application[0]?.userTypeCode
                                                    ?.toLowerCase()
                                                    .replace(/^\w/, (c:any) => c.toUpperCase())}
                                                </span> 

                                                {application[0]?.applicationStatus && (
                                                <span className="badge text-bg-secondary bg-opacity-25 text-dark font-12 font-400 rounded-pill ms-2">
                                                    {getDomainValueForCode(application[0]?.applicationStatus, 'JOB_APPLICATION_STATUS', state)}
                                                 </span>
                                                )}
                                            </h3>
                                           <p className="mb-0">
                                               {application[0]?.programName} {application[0]?.passOutYear} |{' '}
                                               {application[0]?.designation && application[0]?.designation  
                                                ?.toLowerCase()  
                                                .replace(/_/g, ' ')  
                                                .replace(/\b\w/g, (char:any) => char.toUpperCase()
                                                )} 
                                                {application[0]?.companyName && `at`}
                                                {' '}{application[0]?.companyName}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <h4 className="font-20 font-600">Contact Information</h4>
                                <div className="bg-gray-f5f5f5 p-4 rounded">
                                    <div className="row g-2">
                                        <div className="col-12">
                                            <span className="font-500">Email: {application[0]?.contactEmail}</span> 
                                        </div>
                                        <div className="col-12">
                                            <span className="font-500">Phone: 
                                                {' '}{application[0]?.mobileCountryCode && `+${application[0]?.mobileCountryCode}`}
                                                {' '}{application[0]?.phone}
                                            </span> 
                                        </div>
                                        <div className="col-12">
                                            <span className="font-500">Location:{' '}
                                                {application[0]?.cityCode &&
                                                (getDomainValueForCode(application[0]?.cityCode, 'CITY_CODE', state) ?? '')} 
                                                {application[0]?.cityCode && application[0]?.countryCode && ', '}
                                                {getDomainValueForCode(application[0]?.countryCode, 'COUNTRY_CODE', state) ?? ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <h4 className="font-20 font-600">Professional Details</h4>
                                <div className="bg-gray-f5f5f5 p-4 rounded">
                                    <div className="row g-2">
                                        <div className="col-12">
                                            <span className="font-500">Experience: {' '}
                                                {getDomainValueForCode(application[0]?.experience, 'WORK_EX_PREFERENCE', state)}
                                                </span> 
                                        </div>
                                        <div className="col-12">
                                            <span className="font-500">Current Role: {' '}
                                                 {application[0]?.designation && application[0]?.designation  
                                                ?.toLowerCase()  
                                                .replace(/_/g, ' ')  
                                                .replace(/\b\w/g, (char:any) => char.toUpperCase()
                                                )} 
                                                {application[0]?.companyName && `at`}
                                                {' '}{application[0]?.companyName}</span> 
                                        </div>
                                        <div className="col-12">
                                            <span className="font-500">Availability: {' '}
                                            {getDomainValueForCode(application[0]?.availability, 'AVAILABILITY_STATUS', state)}</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {application[0]?.coverLetter && (
                                <div className="col-12">
                                    <h4 className="font-20 font-600">Cover Letter</h4>
                                    <div className="bg-gray-f5f5f5 p-4 rounded">
                                        <p className="mb-0">{application[0]?.coverLetter}</p>
                                    </div>
                                </div>
                            )}
                            {application[0]?.resumeUrl && (
                            <div className="col-12">
                                <h4 className="font-20 font-600">Resume</h4>
                                <div className="bg-gray-f5f5f5 p-4 rounded">
                                    <div className="row g-2 align-items-center">
                                        <div className="col-sm">
                                            <div className="row g-3 align-items-center">
                                                <div className="col-auto">
                                                    <i className="bi bi-filetype-pdf font-48"></i>
                                                </div>
                                                <div className="col">
                                                    <p className="mb-0 font-16 font-500">
                                                        {application[0]?.resumeUrl}
                                                    </p>
                                                    <span className="font-14">
                                                        Uploaded {getTimeAgo(application[0]?.createdAt)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-auto">
                                            <a
                                                href={application[0]?.resumeUrl}
                                                className="btn-green"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                <i className="bi bi-download text-white me-2"></i>
                                               <span>Download</span> 
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                            <div className="col-12">
                                {application[0]?.createdJobuser == sessionState?.id && (
                                    <>
                                        <h4 className="font-20 font-600">Application Status</h4>
                                        <select
                                        className="form-select mb-3"
                                        aria-label="Default select example"
                                        id="sending_reason"
                                        value={applicationStatus}
                                        onChange={(e) => handleChangeApplicationStatus(e.target.value)}>
                                        <option value="" disabled>Select Application Status </option>
                                        {applicationStatuses?.map((option: any) => (
                                            <option value={option.code} key={option.code}>
                                                {option.value}
                                            </option>
                                        ))}
                                    </select>
                                    </>
                                )}
                                <div className="bg-gray-f5f5f5 p-4 rounded">
                                    <div className="row g-2 align-items-center">
                                        <div className="col-12">
                                            <span className="font-500">Applied:</span>{' '}
                                            {getTimeAgo(application[0]?.createdAt)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-12">
                                <div className="row g-2 justify-content-center">
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-border-gray height-40"
                                            onClick={() =>
                                                dispatch({
                                                    type: 'TOGGLE_MODAL_VISIBILITY',
                                                    payload: { modalName: 'showJobViewApplication' },
                                                })
                                            }
                                        >
                                            <span>Cancel</span>
                                        </button>
                                    </div>
                                    {application[0]?.createdJobuser == sessionState?.id && (
                                    <div className="col-auto">
                                        <button className="btn btn-green max-135"
                                        onClick={() => submitApplication(application[0]?.primaryAppliedId)}>
                                            <span>SUBMIT</span>
                                        </button>
                                    </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewApplicationModal;
